// extracted by mini-css-extract-plugin
export default {"main":"ProjectMonitoring_main__oU7Be","actions":"ProjectMonitoring_actions__NMIk0","modaldatelabel":"ProjectMonitoring_modaldatelabel__XZnrk"};